import React from "react";
import {
  Box,
  Stack,
  ThemeIcon,
  Text,
  Paper,
  Button,
  Group as MantineGroup,
} from "@mantine/core";
import { IconCheck, IconLock, IconClock } from "@tabler/icons-react";

const DataCollectionIntro = ({
  icon,
  title,
  componentKey,
  inputSize,
  data,
  onStart,
  bounceTransition,
  theme,
}) => {
  return (
    <Box
      style={{
        flex: 1,
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
      }}
    >
      <Box>

      <Stack
        spacing={inputSize === "md" ? "md" : "sm"}
        align="center"
        style={{ flexGrow: 1 }}
      >
        <ThemeIcon
          variant="light"
          c={data.styles?.primaryColor ? data.styles.primaryColor : "teal"}
          size={inputSize === "md" ? 85 : 70}
          radius="xl"
        >
          {icon}
        </ThemeIcon>
        <Text fz={inputSize === "md" ? 30 : 24} fw={700} align="center">
          {title}
        </Text>
        <Text align="center" fz={inputSize}>
          {componentKey === "idmatch/coppa"
            ? "To continue, we'll quickly confirm your identity. You'll be asked to provide your legal name, date of birth, and SSN."
            : "To continue, we'll quickly confirm your identity. You'll be asked to provide your legal name, address, and date of birth."}
        </Text>
        <Paper
          withBorder
          p={inputSize === "md" ? "md" : "sm"}
          style={{
            backgroundColor:
              theme.colorScheme === "dark" ? theme.colors.dark[6] : "#fafafa",
            width: "100%",
          }}
        >
          <Stack spacing={inputSize === "md" ? "lg" : "md"}>
            <MantineGroup noWrap spacing="sm">
              <IconCheck size={inputSize === "md" ? 30 : 24} />
              <Text fz={inputSize === "md" ? 18 : 16}>
                Simple and secure identity check
              </Text>
            </MantineGroup>
            <MantineGroup noWrap spacing="sm">
              <IconLock size={inputSize === "md" ? 30 : 24} />
              <Text fz={inputSize === "md" ? 18 : 16}>
                Your details are kept private and protected
              </Text>
            </MantineGroup>
            <MantineGroup noWrap spacing="sm">
              <IconClock size={inputSize === "md" ? 30 : 24} />
              <Text fz={inputSize === "md" ? 18 : 16}>
                Takes less than 1 minute to complete
              </Text>
            </MantineGroup>
          </Stack>
        </Paper>
      </Stack>
      </Box>
        <Box style={{ marginTop: "15px", marginBottom: "20px" }}>
      <Button
        size="lg"
        fullWidth
        onClick={onStart}
        sx={{
          transition: `all 0.5s ${bounceTransition}`,
          "&:hover": { transform: "scale(1.01)" },
        }}
      >
        Get started
      </Button>
      </Box>
    </Box>
  );
};

export default DataCollectionIntro;

